import styled from '@emotion/styled';

import BaseCard from 'components/global/Card';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	height: 100%;
	background-color: ${({ pageBackgroundColor }) => pageBackgroundColor ?? 'var(--bgColor)'};
`;

export const FormHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 1rem;
	> button {
		body[dir='rtl'] & {
			.button-icon {
				transform: scaleX(-1);
			}
		}
	}
`;

export const NavBar = styled.nav`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 8rem;
	border: 1px solid transparent;
	background-color: ${({ navigationBackgroundColor }) => navigationBackgroundColor ?? 'var(--white)'};
	box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15);
`;

export const NavBarContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	max-width: 170rem;
	width: 100%;
	padding: 0 15rem;
	@media ${Breakpoints.tablet} {
		padding: 0 10rem;
	}
	@media ${Breakpoints.mobile} {
		padding: 0 2rem;
	}
`;

export const ScrollContainer = styled.div`
	height: calc(100% - 8rem);
	overflow-y: auto;
	padding-bottom: 2.5rem;
`;

export const Content = styled.div`
	display: flex;
	justify-content: center;
	padding-top: 3rem;
	padding-bottom: 5rem;
	gap: 3rem;
	@media ${Breakpoints.tablet} {
		flex-direction: column;
	}
`;

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 50%;
	max-width: 100rem;
	min-height: 70rem;

	> div {
		max-width: 100rem;
		width: 100%;
	}

	@media ${Breakpoints.tablet} {
		width: 80%;
		margin: 0 auto;
		padding-top: 0;
	}

	@media ${Breakpoints.mobile} {
		width: 100%;
	}
`;

export const ResultContainer = styled.div`
	display: flex;
	justify-content: center;
	padding: 10rem 0;
`;

export const Card = styled(BaseCard)`
	border-radius: 3rem !important;
	min-height: inherit;
	max-width: 65rem;
	width: 100%;
`;

export const SuccessWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 5.5rem 4.5rem;
	gap: 3rem;
	@media ${Breakpoints.mobile} {
		padding: 5.5rem 1.5rem;
	}
`;

export const SuccessInfoContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 1.5rem;
	text-align: center;
	padding: 0 2rem;
`;

export const ErrorWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 5.5rem 4.5rem;
	gap: 3rem;
	@media ${Breakpoints.mobile} {
		padding: 5.5rem 1.5rem;
	}
`;

export const ErrorInfoContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 1.5rem;
	text-align: center;
	padding: 0 2rem;
`;

export const OrderSummary = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	background: #f6f6f6;
	width: 100%;
	padding: 2rem 3rem;
`;

export const OrderSummaryRow = styled.div`
	display: flex;
	justify-content: space-between;
`;
